import React from 'react';
import clsx from 'clsx';
import { isEmpty } from 'lodash';
import { CropSquare, CheckBox } from '@mui/icons-material';
import { Icons, IconButton, Box, List, ListItem, ListItemIcon, ListItemText } from "@curves/ui-base";
import { useInBodyContext } from '@icoach/inbody/components/InBodyContext';

const InBodyAgreedNotesBox = React.forwardRef((props, ref) => {
    const { sourceData = [], measureID } = props;
    const { dialogRef, peopleID, refresh} = useInBodyContext();

    const handleAgreedNotesOnClick = () => {
        dialogRef.current.openInBodyAgreedNotesDialog({ list: sourceData, measureID, memberID: peopleID }, refresh);
    };

    const isEmptyData = isEmpty(sourceData);

    return (
        <Box className={clsx('cursor-pointer inbody-agreed-notes-box', { 'text-left': !isEmptyData })} onClick={handleAgreedNotesOnClick}>
            {isEmptyData ? (
                <IconButton>
                    <Icons.Edit />
                </IconButton>
            ) : (
                <List className={'inbody-agreed-notes-box__list'}>
                    {sourceData.map(({ measureTaskID, taskTitle, isCompleted }) => (
                        <ListItem key={measureTaskID} className={'inbody-agreed-notes-box__item'} alignItems={'flex-start'}>
                            <ListItemIcon>{isCompleted ? <CheckBox /> : <CropSquare />}</ListItemIcon>
                            <ListItemText primary={taskTitle} />
                        </ListItem>
                    ))}
                </List>
            )}
        </Box>
    );
});

export default InBodyAgreedNotesBox;
